import React, { useEffect, useState } from 'react';

const HeartAnimation = ({ isVisible, onComplete }) => {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    if (isVisible) {
      // 12개의 하트 생성
      const newHearts = Array.from({ length: 12 }, (_, i) => ({
        id: i,
        left: Math.random() * 100, // 0-100% 랜덤 위치
        delay: Math.random() * 1000, // 0-1초 랜덤 딜레이
        size: 0.8 + Math.random() * 0.7, // 0.8-1.5 랜덤 크기
        duration: 2000 + Math.random() * 1000, // 2-3초 랜덤 지속시간
        hearts: ['💖', '💕', '💝', '❤️', '🧡', '💛', '💚', '💙', '💜'][Math.floor(Math.random() * 9)]
      }));
      setHearts(newHearts);

      // 3초 후 완료 콜백
      const timer = setTimeout(() => {
        onComplete?.();
        setHearts([]);
      }, 3500);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onComplete]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      {hearts.map((heart) => (
        <div
          key={heart.id}
          className="absolute bottom-0 animate-float-up"
          style={{
            left: `${heart.left}%`,
            animationDelay: `${heart.delay}ms`,
            animationDuration: `${heart.duration}ms`,
            fontSize: `${heart.size * 2}rem`,
            transform: 'translateX(-50%)'
          }}
        >
          {heart.hearts}
        </div>
      ))}
      
      <style jsx>{`
        @keyframes float-up {
          0% {
            transform: translateY(0) translateX(-50%) rotate(0deg);
            opacity: 1;
          }
          50% {
            transform: translateY(-50vh) translateX(-50%) rotate(180deg);
            opacity: 0.8;
          }
          100% {
            transform: translateY(-100vh) translateX(-50%) rotate(360deg);
            opacity: 0;
          }
        }
        
        .animate-float-up {
          animation: float-up 3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default HeartAnimation;